import React, { Component } from 'react';
import I18n from '../locales/i18n';

class WizardForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			step: 1,
		};

		this.onChangeStep = this.onChangeStep.bind(this);
		this.onNextStep = this.onNextStep.bind(this);
	}

	onChangeStep(newValue) {
		this.setState({ step: newValue });
	}
	onNextStep(e) {
		let newValue = this.state.step + 1;
		this.setState({ step: newValue });
	}
	render() {
		const totalTabs = this.props.children.length - 1;
		return (
			<div className="wizard-container">
				{this.props.children.map(function (Tab, index) {
					return React.cloneElement(Tab, {
						key: index,
						isFirst: index === 0,
						number: index + 1,
						step: this.state.step,
						onChangeStep: this.onChangeStep,
						onNextStep: this.onNextStep,
						isLast: index === totalTabs,
						isEditing: this.props.isEditing,
					});
				}, this)}
			</div>
		);
	}
}

class WizardTab extends Component {
	constructor(props) {
		super(props);
		this.state = {
			wasCompleted: false,
			wasViewed: this.props.step === this.props.number,
		};

		this.onHeaderClick = this.onHeaderClick.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	componentWillReceiveProps(nP) {
		if (nP.step === this.props.number && !this.state.wasViewed) {
			this.setState({ wasViewed: true });
		}
	}

	complete() {
		this.setState({
			wasCompleted: true,
			wasViewed: true,
		});
	}

	enable(idx) {
		this.setState(
			{
				wasViewed: true,
			},
			() => {
				this.props.onChangeStep(this.props.number);
			}
		);
	}

	onHeaderClick(e) {
		if (this.state.wasViewed || this.props.isEditing) {
			this.props.onChangeStep(this.props.number);
		}
	}
	onSubmit(e) {
		e.preventDefault();
		if (typeof this.props.onSubmit === 'function') {
			this.props.onSubmit(e, (validate) => {
				if (validate) {
					this.setState({ wasCompleted: true }, () => {
						this.props.onNextStep();
					});
				}
			});
		} else {
			this.setState({ wasCompleted: true }, () => {
				this.props.onNextStep();
			});
		}
	}
	render() {
		const status =
			this.props.step === this.props.number ||
			(this.state.wasViewed && !this.state.wasCompleted)
				? 'IN_PROGRESS'
				: this.state.wasCompleted
				? 'COMPLETED'
				: 'TO_DO';
		return (
			<div
				className={
					'tab' +
					(this.props.step === this.props.number ? ' active' : '') +
					(this.props.step < this.props.number && !this.state.wasCompleted
						? ' todo'
						: '')
				}
			>
				<div className="tab-header" onClick={this.onHeaderClick}>
					{this.props.isFirst && <span className="tab-fix"></span>}
					<span className="tab-number">{this.props.number}</span>
					<span className="tab-title">{this.props.title}</span>
					<span className="tab-status">{I18n('WIZARD_FORM', status)}</span>
				</div>
				<div className="tab-body">
					<form onSubmit={this.onSubmit}>
						{this.props.children}

						<div
							className={
								'tab-footer' + (this.props.noShowFooter ? ' hide' : '')
							}
						>
							{!this.props.noSubmit && (
								<button
									type="submit"
									className="btn btn-large btn-indigo btn-tab-next"
									disabled={this.props.isLoading}
								>
									{this.props.isLast || this.props.isEditing
										? I18n('WIZARD_FORM', 'SAVE')
										: I18n('WIZARD_FORM', 'NEXT')}{' '}
									<i
										className={
											'fas fa-' +
											(this.props.isLast || this.props.isEditing
												? 'save'
												: 'arrow-alt-circle-down')
										}
									></i>
								</button>
							)}
							{this.props.noSubmit && (
								<div className="col-md-12 text-right m-b-20 tab-wizard-form-alert">
									<div
										className="col-md-6 alert alert-outline-danger mg-b-0"
										role="alert"
									>
										<p>
											<span role="img" aria-label="truensio">
												😉
											</span>{' '}
											{I18n('NEW_EVENT', 'EVENT_ENDED')}
										</p>
									</div>
								</div>
							)}
						</div>
					</form>
				</div>
			</div>
		);
	}
}

export { WizardForm, WizardTab };
